// src/pages/profile.js
import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer.js';
import { makeStyles } from '@material-ui/core/styles';
import '../components/spinner.css';
import NavBar from '../components/NavBar';
import CircularProgress from '@material-ui/core/CircularProgress';
import ProfileCard from '../components/ProfileCard';
import { isMobile } from '../utils/util.js';
import { Button, Paper, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    background: isMobile ? '#f5f8f5' : '#f5f8f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: 1,
  },
}));

export function LoggedIn() {
  const classes = useStyles();
  const [user, setUser] = useState('loading');
  const [isQutStudent, setIsQutStudent] = useState(false);
  const [draft, setDraft] = useState(null);
  const [draftError, setDraftError] = useState(false);

  const checkDraft = async () => {
    setDraftError(false);
    try {
      const response = await fetch('/api/results/draft', { credentials: 'include' });
      if (!response.ok) throw new Error('Unable to check saved assessment');
      const data = await response.json();
      setDraft(data.draft);
    } catch {
      setDraftError(true);
    }
  };

  useEffect(() => {
    // Load data for ProfileCard (existing endpoint)
    const getUser = async () => {
      try {
        const response = await fetch('/api/user', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const data = await response.json();
        setUser(data);
      } catch {
        setUser({ error: 'Failed to load profile.' });
      }
    };

    // Determine if this session is a QUT student login
    const getFlags = async () => {
      try {
        const res = await fetch('/api/auth/me', { credentials: 'include' });
        const data = await res.json();
        setIsQutStudent(res.ok && data?.success ? !!data.flags?.isQutStudent : false);
      } catch {
        setIsQutStudent(false);
      }
    };

    getUser();
    getFlags();
    checkDraft();
  }, []);

  const renderContent = () => {
    if (user === 'loading') {
      return (
        <div className="loader">
          <CircularProgress />
        </div>
      );
    }
    if (user?.error) {
      return <div style={{ padding: 16 }}>{user.error}</div>;
    }
    return (
      <ProfileCard
        lastSurveyCompleted={user.lastSurveyCompleted}
        fullName={user.fullName}
        picture={user.picture}
        provider={user.provider}
        accountCreated={user.accountCreated}
        completedSurveys={user.completedSurveys}
        hasDraft={!!draft}
      />
    );
  };

  return (
    <div className={classes.root}>
      {/* Show Cohort (→ /dashboard) only for QUT students */}
      <NavBar isLoggedIn={true} showCohorts={isQutStudent} />

      <main className={`${classes.content} emap-profile-content`}>
        {draft && <Paper className="emap-resume-card">
          <div><p className="emap-card-kicker">Ready when you are</p><Typography variant="h6">Pick up where you left off</Typography>
          <Typography>Your answers and place in the assessment are saved to this account.</Typography></div>
          <Button component={Link} to="/questions" variant="contained" color="primary">Resume assessment</Button>
        </Paper>}
        {draftError && <Paper role="alert" style={{ margin: 24, padding: 16 }}>
          <Typography>We could not check for an unfinished assessment. Retry before starting another.</Typography>
          <Button onClick={checkDraft}>Check saved assessment</Button>
        </Paper>}
        {renderContent()}
      </main>
      <Footer />
    </div>
  );
}

export default LoggedIn;


